import { type IPostCandidatesSearch, plurialize } from "@api";
import { Stack, Typography } from "@mui/material";
import { GridVirtualizedSelect } from "@styleguide";
import type { Dispatch, MutableRefObject, SetStateAction } from "react";
import { CandidateItem } from "./candidateItem";

interface ISelectedCandidatesGrid {
  selectedCandidates: IPostCandidatesSearch["data"];
  localSelectedCandidates: IPostCandidatesSearch["data"];
  setLocalSelectedCandidates: Dispatch<SetStateAction<IPostCandidatesSearch["data"]>>;
  scrollerRef: MutableRefObject<HTMLDivElement | null>;
}

export const SelectedCandidatesGrid = ({
  selectedCandidates,
  localSelectedCandidates,
  setLocalSelectedCandidates,
  scrollerRef,
}: ISelectedCandidatesGrid) => {
  const onChange = (selectedItems: IPostCandidatesSearch["data"]) => {
    setLocalSelectedCandidates(selectedItems);
  };

  return (
    <GridVirtualizedSelect
      data={selectedCandidates}
      selectedItems={localSelectedCandidates}
      customScrollParent={scrollerRef.current ?? undefined}
      getId={(item: Pick<IPostCandidatesSearch["data"][number], "profileId">) => `${item.profileId}`}
      emptyContent={() => <Typography variant="body1">Aucun candidat sélectionné.</Typography>}
      onChange={onChange}
      itemContent={(_, candidate) => <CandidateItem candidate={candidate} />}
      headerContent={() => (
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body1Bold">
            Sélectionnés : {localSelectedCandidates.length} {plurialize("candidat", localSelectedCandidates.length)}
          </Typography>
        </Stack>
      )}
    />
  );
};
